import * as React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { City } from 'lib/types';

export const citiesQuery = graphql`
    query Cities {
        allCity {
            nodes {
                id
                slug
                label
                sortOrder
            }
        }
    }
`;

type CitiesQuery = {
    allCity: {
        nodes: ReadonlyArray<City>;
    };
};

export default function useCities(): ReadonlyArray<City> {
    const {
        allCity: { nodes: cities },
    } = useStaticQuery<CitiesQuery>(citiesQuery);

    return React.useMemo(() => {
        return [...cities].sort((a, b) => {
            if (a.sortOrder !== undefined && b.sortOrder !== undefined) {
                return a.sortOrder - b.sortOrder;
            }

            return a.label.localeCompare(b.label);
        });
    }, [cities]);
}
